import { Component } from '@angular/core';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
@Component({
  selector: 'app-home-otherpages',
  templateUrl: './home-otherpages.component.html',
  styleUrls: ['./home-otherpages.component.scss']
})
export class HomeOtherpagesComponent {
  translator:TranslatorPipe = new TranslatorPipe();
  
  translate(key:string) {
    let translator:TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


  items = [
    { 
      title:  this.translate('Services'),
      text: this.translate('If you are looking for services and their details, click the button below.'),
      routerLink: "/services",
      btn: this.translate('Press here'),
      icon: "pi-file"
    },
    { 
      title: this.translate('common questions'),
      text: this.translate('If you are looking for FAQs that can help you better help customers. Click the button below.'),
      routerLink: "/faq",
      btn: this.translate('Press here'),
      icon: "pi-question"
    },
    { 
      title: this.translate('National Directory of Economic Activities (ISIC4)'),
      text: this.translate('If you are looking for the National Directory of Economic Activities (ISIC4) that can better help you assist customers. Click the button below.'),
      routerLink: "/ISIC",
      btn: this.translate('Press here'),
      icon: "pi-building"
    },
    { 
      title: this.translate('Closed cases'),
      text: this.translate('Take a look at past queries and solutions that helped our team.'),
      routerLink: "/services",
      btn: this.translate('Press here'),
      icon: "pi-briefcase"
    }
  ]

}
